import { call, put, select, takeEvery } from 'redux-saga/effects';

import { LOCATION_ASSIGN } from 'constants/appConstants';
import { CLOSED_LA_COOKIE } from 'constants/cookies';
import { REDIRECT } from 'constants/reduxActions';
import { getLoginAssistantContent } from 'apis/mafia';
import { trackError } from 'helpers/ErrorUtils';
import { buildAuthenticationRedirectUrl } from 'utils/redirect';
import { setAndStoreCookie } from 'actions/session';
import {
  BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT,
  CLOSE_LA,
  FETCH_LOGIN_ASSISTANT_CONTENT_ERROR,
  LOGIN_FROM_LA,
  RECEIVE_LOGIN_ASSISTANT_CONTENT,
  REDIRECT_FROM_LA
} from 'store/ducks/loginAssistant/types';
import marketplace from 'cfg/marketplace.json';
import { ABSOLUTE_URL_RE } from 'common/regex';

const { desktopBaseUrl } = marketplace;

export function* watchLoginFromLoginAssistant() {
  yield takeEvery(LOGIN_FROM_LA, workLoginFromLoginAssistant);
}

export function* watchRedirectFromLoginAssistant() {
  yield takeEvery(REDIRECT_FROM_LA, workRedirectFromLoginAssistant);
}

export function* workLoginFromLoginAssistant({ redirectPath }) {
  yield put({ type: REDIRECT, location: buildAuthenticationRedirectUrl(redirectPath), method: LOCATION_ASSIGN });
}

export function* workRedirectFromLoginAssistant({ redirectPath }) {
  const isAbsoluteUrl = ABSOLUTE_URL_RE.test(redirectPath);
  const location = isAbsoluteUrl ? redirectPath : `${desktopBaseUrl}${redirectPath}`;
  yield put({ type: REDIRECT, location, method: LOCATION_ASSIGN });
}

export function* watchCloseLoginAssistant() {
  yield takeEvery(CLOSE_LA, workCloseLoginAssistant);
}

export function* workCloseLoginAssistant({ mockDate }) {
  const monthFromNow = mockDate || new Date();
  monthFromNow.setDate(monthFromNow.getDate() + 30);
  yield put(setAndStoreCookie(CLOSED_LA_COOKIE, 1, monthFromNow));
}

export function* watchFetchLoginAssistantContent() {
  yield takeEvery(BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT, workFetchLoginAssistantContent);
}

export function* workFetchLoginAssistantContent() {
  try {
    const { environmentConfig } = yield select();
    const { api: { mafia } } = environmentConfig;
    const response = yield call(getLoginAssistantContent, mafia);
    const content = yield response.json();
    yield put({ type: RECEIVE_LOGIN_ASSISTANT_CONTENT, content });
  } catch (error) {
    yield put({ type: FETCH_LOGIN_ASSISTANT_CONTENT_ERROR, payload: { error } });
    yield call(trackError, 'NON-FATAL', 'Could not retrieve login assistant content', error);
  }
}

export default [
  watchCloseLoginAssistant,
  watchFetchLoginAssistantContent,
  watchLoginFromLoginAssistant,
  watchRedirectFromLoginAssistant
];
